import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "gettingStartedModal",
    "form"
  ]

  connect() {
    if (this.element.getAttribute("show-getting-started-modal") === "true") {
      this.showGettingStartedModal();
    }
  }

  showGettingStartedModal() {
    this.gettingStartedModalTarget.classList.remove("hidden");
    document.querySelector("[data-footer]").classList.add("hidden");
  }

  getStarted(e) {
    e.preventDefault()
    this.gettingStartedModalTarget.classList.add("hidden")
    document.querySelector("[data-footer]").classList.remove("hidden")
  }

  back(e) {
    e.preventDefault();
    this.formTarget.querySelector("[name=direction]").value = "back";
    this.formTarget.submit();
  }

  next(e) {
    e.preventDefault();
    this.formTarget.querySelector("[name=direction]").value = "next";
    this.formTarget.submit();
  }

  seePDF(e) {
    e.preventDefault();
    this.formTarget.querySelector("[name=direction]").value = "pdf";
    this.formTarget.submit();
  }

  // For the methods below, we'd like to submit them as turbo requests, but for that we would need to mark them up as <form>'s, and we
  // can't do that because we already have another form enclosing the entire section.  So, we're using JS to manually send the requests.

  showSectionMenu(e) {
    e.preventDefault();

    var link = e.currentTarget;

    var applicationId = link.getAttribute("data-application-id");

    var url = `/v2/charity_care_applications/${applicationId}/section_menu_modal`;

    let httpRequest = new XMLHttpRequest();
    httpRequest.open("GET", url);
    httpRequest.onreadystatechange = () => {
      if (httpRequest.readyState === XMLHttpRequest.DONE) {
        if (httpRequest.status === 200) {
          Turbo.renderStreamMessage(httpRequest.responseText);
        }
      }
    }

    httpRequest.send();
  }

  editRow(e) {
    e.preventDefault();

    var link = e.currentTarget;

    var applicationId = link.getAttribute("data-application-id");
    var tableFieldId = link.getAttribute("data-table-field-id");
    var tableName = link.getAttribute("data-table-name");
    var rowIndex = link.getAttribute("data-row-index");

    var url = `/v2/charity_care_applications/${applicationId}/table_row_modal?table_field_id=${tableFieldId}&table_name=${encodeURIComponent(tableName)}&row_index=${rowIndex}`;

    let httpRequest = new XMLHttpRequest();
    httpRequest.open("GET", url);
    httpRequest.onreadystatechange = () => {
      if (httpRequest.readyState === XMLHttpRequest.DONE) {
        if (httpRequest.status === 200) {
          Turbo.renderStreamMessage(httpRequest.responseText);
        }
      }
    }

    httpRequest.send();
  }

  removeRow(e) {
    e.preventDefault();

    var link = e.currentTarget;

    var applicationId = link.getAttribute("data-application-id");
    var tableFieldId = link.getAttribute("data-table-field-id");
    var tableName = link.getAttribute("data-table-name");
    var rowIndex = link.getAttribute("data-row-index");

    var url = `/v2/charity_care_applications/${applicationId}/remove_table_row?table_field_id=${tableFieldId}&table_name=${encodeURIComponent(tableName)}&row_index=${rowIndex}`;

    let httpRequest = new XMLHttpRequest();
    httpRequest.open("POST", url);
    httpRequest.onreadystatechange = () => {
      if (httpRequest.readyState === XMLHttpRequest.DONE) {
        if (httpRequest.status === 200) {
          Turbo.renderStreamMessage(httpRequest.responseText);
        }
      }
    }

    httpRequest.send();
  }
}
